import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/pos/Registradora.vue'
import store from "@/store"
import { webserver } from '@/services/webserver.js'

Vue.use(VueRouter)

// NOTA: Router reorganizado por funcionalidades
// Usando @ para imports absolutos y evitar problemas de rutas

const routes = [
    // === RUTAS PRINCIPALES ===
    // Inicio: si no autenticado, router guard redirige a Login; al estar autenticado, muestra Home
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true,
            is_admin: true
        },
        beforeEnter: (to, from, next) => {
            const billingMode = store.state.billingMode || (window.store && window.store.billing_mode) || 'register';
            if (billingMode !== 'register') return next();

            const profileStoreId = (window.profile && window.profile.store_id) || (window.store && window.store.store_id);
            if (!profileStoreId) return next();
            const idPos = String(profileStoreId).substring(0, 6);

            const qry = {
                store: profileStoreId,
                table: 'tablas',
                filters: [
                    { field: 'tabla', operator: '=', value: 'CATEGORIA' },
                    { field: 'id_pos', operator: '=', value: idPos }
                ]
            };
            webserver('get_dataTable', qry, (data) => {
                if (data && data.error) return next();
                if (Array.isArray(data) && data.length > 0) return next();
                next({ path: '/Settings', query: { tabla: 'CATEGORIA', reason: 'no_categories' } });
            });
        }
    },

    // === VENDEDOR (móvil) ===
    {
        path: '/Vendedor',
        name: 'Vendedor',
        component: () => import('@/views/Vendedor/VendedorPanel.vue'),
        meta: {
            requiresAuth: true,
            is_admin: false
        }
    },

    // === AUTENTICACIÓN ===
    {
        path: '/Login',
        name: 'Login',
        props: true,
        // Login unificado: usar directamente el formulario de login
        component: () => import('@/components/LoginFrom.vue'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },

    // === LANDING PAGE ===
    {
        path: '/home',
        name: 'HomePage',
        component: () => import('@/views/Landing/HomePage.vue'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },
    {
        path: '/demo',
        name: 'DemoPage',
        component: () => import('@/views/Landing/DemoPage.vue'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },

    // === DASHBOARD ===
    {
        path: '/About',
        name: 'About',
        component: () => import('@/views/Dashboard/About.vue'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },

    // === ANALISTA ===
    {
        path: '/AnalystDashboard',
        name: 'AnalystDashboard',
        component: () => import('@/views/Analista/AnalystDashboard.vue'),
        meta: {
            requiresAuth: true,
            is_admin: false
        }
    },

    // === ANÁLISIS POR TIENDA ===
    {
        path: '/StoreDashboard',
        name: 'StoreDashboard',
        component: () => import('@/views/Analista/StoreDashboard.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/SalesAnalysis',
        name: 'SalesAnalysis',
        component: () => import('@/views/Analista/SalesAnalysis.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/InventoryAnalysis',
        name: 'InventoryAnalysis',
        component: () => import('@/views/Analista/InventoryAnalysis.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/ProfitAnalysis',
        name: 'ProfitAnalysis',
        component: () => import('@/views/Analista/ProfitAnalysis.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === FACTURACIÓN ELECTRÓNICA ===
      {
        path: '/apiCompanies',
        name: 'apiCompanies',
        component: () => import('@/views/facturae/co/FE_companies.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
      {
        path: '/apiSettings',
        name: 'apiSettings',
        component: () => import('@/views/facturae/co/FE_settings.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/InvoiceE',
        name: 'InvoiceE',
        component: () => import('@/views/Facturacion/InvoiceE.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Invoices',
        name: 'Invoices',
        component: () => import('@/views/Facturacion/Invoices.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/CreditNotes',
        name: 'CreditNotes',
        component: () => import('@/views/Facturacion/Invoices_nc.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/invoices_pos',
        name: 'invoices_pos',
        component: () => import('@/views/Facturacion/invoices_pos.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/InvoicePOS',
        name: 'InvoicePOS',
        component: () => import('@/views/Facturacion/InvoicePOS.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
 {
        path: '/InvoiceQ',
        name: 'InvoiceQ',
        component: () => import('@/views/Facturacion/InvoiceQ.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === PUNTO DE VENTA (POS) ===
    {
        path: '/plu',
        name: 'plu',
        component: () => import('@/views/pos/comanda.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/PLU',
        name: 'PLU',
        component: () => import('@/views/pos/comanda.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === CAJA ===
    {
        path: '/CashReports',
        name: 'CashReports',
        component: () => import('@/views/Caja/Cash_report.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/DailyReport',
        name: 'DailyReport',
        component: () => import('@/views/Caja/Daily_Report.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/CashDocs',
        name: 'CashDocs',
        component: () => import('@/views/Caja/Cash_docs.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Resume',
        name: 'Resume',
        component: () => import('@/views/Caja/Store_resume.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/CashFlowReport',
        name: 'CashFlowReport',
        component: () => import('@/views/Caja/CashFlowReport.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
        {
        path: '/Cash_report',
        name: 'Cash_report',
        component: () => import('@/views/Caja/Cash_report.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Receipt_in',
        name: 'Receipt_in',
        component: () => import('@/views/Caja/Receipt_in.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Receipt_out',
        name: 'Receipt_out',
        component: () => import('@/views/Caja/Receipt_out.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === INVENTARIO ===
    {
        path: '/inventory_status',
        name: 'inventory_status',
        component: () => import('@/views/Inventario/inventory_status.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/AuditoriaInventario',
        name: 'AuditoriaInventario',
        component: () => import('@/views/Auditoria/AuditoriaInventario.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/AuditoriaEnVivo',
        name: 'AuditoriaEnVivo',
        component: () => import('@/views/Auditoria/AuditoriaEnVivo.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Events',
        name: 'Events',
        component: () => import('@/views/Inventario/Get_events.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Inventory',
        name: 'Inventory',
        component: () => import('@/views/Inventario/Inventory.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/G_search',
        name: 'G_search',
        component: () => import('@/views/Inventario/Global_search.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    // Inventory Adjustment Routes
    {
        path: '/IAIn',
        name: 'IAIn',
        component: () => import('@/views/Inventario/IAIn.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/IAOut',
        name: 'IAOut',
        component: () => import('@/views/Inventario/IAOut.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/WarrantyIn',
        name: 'WarrantyIn',
        component: () => import('@/views/Inventario/Warranty_in.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/WarrantyOut',
        name: 'WarrantyOut',
        component: () => import('@/views/Inventario/Warranty_out.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Warehouse',
        name: 'Warehouse',
        component: () => import('@/views/Inventario/Warehouse.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Promotion',
        name: 'Promotion',
        component: () => import('@/views/Inventario/Promotion.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === COMPRAS ===
    {
        path: '/StockImport',
        name: 'StockImport',
        component: () => import('@/views/Compras/Stock_import.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Orders',
        name: 'Orders',
        component: () => import('@/views/Compras/Orders.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Order',
        name: 'Order',
        component: () => import('@/views/Compras/Order.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Master',
        name: 'Master',
        component: () => import('@/views/Compras/Master.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Proveedores',
        name: 'Proveedores',
        component: () => import('@/views/Compras/Proveedores.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === ADMINISTRACIÓN ===
    {
        path: '/Company',
        name: 'Company',
        component: () => import('@/views/Settings/Company.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Clients',
        name: 'Clients',
        component: () => import('@/views/Admin/Clients.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/ClientsDebug',
        name: 'ClientsDebug',
        component: () => import('@/views/Admin/ClientsDebug.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Users',
        name: 'Users',
        component: () => import('@/views/Admin/Users.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/Settings',
        name: 'Settings',
        component: () => import('@/views/Admin/Settings.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
        {
        path: '/ConsecutivosManager',
        name: 'ConsecutivosManager',
        component: () => import('@/views/Facturacion/ConsecutiveManager.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    
    {
        path: '/Vendors',
        name: 'Vendors',
        component: () => import('@/views/Admin/Vendors.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/VendorsStat',
        name: 'VendorsStat',
        component: () => import('@/views/Admin/VendorsStat.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },

    // === INTELIGENCIA ARTIFICIAL ===
    {
        path: '/aibos',
        name: 'aibos',
        component: () => import('@/components/ClaudeAiAssistant.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/aiDocImport',
        name: 'aiDocImport',
        component: () => import('@/views/AI/DocImport.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }

    },
        {
        path: '/aiMasterImport',
        name: 'aiMasterImport',
        component: () => import('@/views/AI/MasterImport.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
        
    },

    // === DOCUMENTOS Y TICKETS ===
    {
        path: '/ticket/:encryptedId',
        name: 'DocumentViewer',
        props: true,
        component: () => import('@/views/ticket/DocumentViewer.vue'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },

     {
        path: '/support',
        name: 'support',
        props: true,
        component: () => import('@/views/Support/AppLayout'),
        meta: {
            requiresAuth: false,
            is_admin: false
        }
    },
    {
        path: '/InvoicesBoard',
        name: 'InvoicesBoard',
        component: () => import('@/views/Facturacion/InvoicesBoard.vue')
    },

    // === INSPECCIONES VEHICULARES ===
    {
        path: '/VehicleInspectionList',
        name: 'VehicleInspectionList',
        component: () => import('@/views/VehicleInspectionList.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/vehicle-inspection/new',
        name: 'VehicleInspection',
        component: () => import('@/views/VehicleInspection.vue'),
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/vehicle-inspection/:id',
        name: 'VehicleInspectionEdit',
        component: () => import('@/views/VehicleInspection.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            is_admin: true
        }
    },
    {
        path: '/vehicle-inspection/view/:id',
        name: 'VehicleInspectionView',
        component: () => import('@/views/VehicleInspection.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            is_admin: false
        }
    },

    // === RUTAS MANTENIDAS POR COMPATIBILIDAD ===
    // Estas pueden necesitar revisión adicional según su uso real

    // === ARCHIVOS REORGANIZADOS ===
    // Los siguientes archivos fueron reorganizados por funcionalidades:
    // 
    // Auth/: Login.vue
    // Dashboard/: About.vue
    // Facturacion/: InvoiceE.vue, Invoices.vue, Invoices_nc.vue, invoices_pos.vue
    // POS/: Registradora.vue, comanda.vue, PLUD.vue
    // Caja/: CashReport.vue, CashReports.vue (+ archivos existentes)
    // Inventario/: inventory_status.vue, StockIn.vue, Stock_docs.vue, Stock_in_report.vue, Warehouse_report.vue (+ archivos existentes)
    // Reportes/: Resolutions.vue
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.profile) {
            if (store.state.profile.token) {
                next()
            } else {
                next({
                    name: 'Login',
                    params: { nextUrl: to.fullPath }
                })
            }
            return
        } else {
            next({
                name: 'Login',
                params: { nextUrl: to.fullPath }
            })
        }
    } else {
        next()
    }
})

export default router
